import { FC, memo } from "react";

import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { Grid, Stack, Text } from "@mantine/core";

import { SelectBox } from "components/sale/SelectBox";
import { SaleType } from "~/features/tokens/sections/ManageToken/MintVector/useSaleForm";

type Props = {
  value: SaleType;
  onChange: (value: SaleType) => void;
  disablePublicSale: boolean;
  isDutchAuction?: boolean;
};

const SaleTypeInput: FC<Props> = ({
  onChange,
  value,
  disablePublicSale,
  isDutchAuction,
}) => {
  return (
    <Stack spacing={8}>
      <Text component="label" size="sm">
        Sale type
      </Text>
      <Grid>
        <Grid.Col span={6}>
          <SelectBox
            disabled={disablePublicSale}
            checked={value === SaleType.PUBLIC}
            label="Public"
            description="Anyone can mint from this sale on Highlight or other platforms"
            onClick={() => onChange(SaleType.PUBLIC)}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <SelectBox
            disabled={false}
            checked={value === SaleType.PRIVATE}
            label="Private"
            description="Only people you choose can mint from this sale on Highlight"
            onClick={() => onChange(SaleType.PRIVATE)}
          />
        </Grid.Col>
      </Grid>
      {isDutchAuction && (
        <Text color={TEXT_COLOR.SECONDARY} size="xs">
          Rebates are always enabled for public sales
        </Text>
      )}
    </Stack>
  );
};

export default memo(SaleTypeInput);
